// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2634 ? "2c796e83" : chunkId) + "." + {"790":"c020416f2c0955d9","1616":"fd586cd855d47411","2634":"5d759fe78072a30e","8379":"59ed8ecdfb69b95e"}[chunkId] + ".js";
};